export const SEO_TEXT_HEIGHT = {
  DESKTOP: 346,
  MOBILE: 210,
  MOBILE_WITH_IMAGE: 370,
};
